"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Link_1 = __importDefault(require("@material-ui/core/Link"));
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var GameSelection = function (_a) {
    var theme = _a.theme, games = _a.games, selectedGame = _a.selectedGame, selectGame = _a.selectGame;
    var classes = styles(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Grid_1.default, { xs: 10 },
        react_1.default.createElement(Typography_1.default, { className: classes.sectionTitle, variant: "h2" }, t('numberChecker.selectGame')),
        react_1.default.createElement(List_1.default, { className: classes.gamesContainer }, games &&
            games.map(function (game) {
                var onSelect = function () { return selectGame(game); };
                return (react_1.default.createElement(ListItem_1.default, { className: classes.gameCard, key: game.id, onClick: onSelect },
                    react_1.default.createElement(Link_1.default, { className: classes.gameCardButton, component: "button", style: {
                            outline: game.id === (selectedGame === null || selectedGame === void 0 ? void 0 : selectedGame.id)
                                ? "2px solid ".concat(theme.palette.grey[700])
                                : "1px solid ".concat(theme.palette.grey[600])
                        } },
                        react_1.default.createElement("img", { src: game.image, className: classes.gameImage, alt: game.name }))));
            })),
        react_1.default.createElement(Typography_1.default, { variant: "body1", className: classes.disclaimer }, t('numberChecker.disclaimer'))));
};
var styles = function (theme) {
    var _a, _b;
    return (0, styles_1.makeStyles)({
        container: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                maxWidth: '80%'
            },
            _a.display = 'flex',
            _a.flexDirection = 'column',
            _a.justifyContent = 'flex-start',
            _a.alignItems = 'center',
            _a),
        gameCard: (_b = {
                width: '195px !important',
                height: '113px',
                margin: '0 12px 16px',
                padding: '0'
            },
            _b[theme.breakpoints.between('sm', 'lg')] = {
                margin: '0 8px 24px'
            },
            _b[theme.breakpoints.down('sm')] = {
                width: '158px'
            },
            _b.border = '0 !important',
            _b),
        gameCardButton: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            width: '195px !important',
            height: '113px',
            padding: '8px 16px',
            border: '1px solid rgb(196, 205, 213)',
            borderRadius: '7px',
            '&.MuiLink-button.Mui-focusVisible': {
                outline: "2px solid ".concat(theme.palette.grey[900], " !important"),
                outlineOffset: '2px',
                boxShadow: "0 0 0 5px ".concat(theme.palette.common.white)
            }
        },
        gameImage: {
            position: 'relative',
            width: '100%',
            cursor: 'pointer'
        },
        sectionTitle: {
            color: theme.palette.grey[700],
            textAlign: 'center'
        },
        gamesContainer: {
            marginTop: '16px !important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap'
        },
        disclaimer: {
            textAlign: 'center'
        }
    });
};
exports.default = GameSelection;
//# sourceMappingURL=GameSelection.js.map